module.exports = {
  system: {
    id: 'e9d14c00-e74c-4520-85c4-0a3f6b6ee9d1',
    internal_name: 'system',
    name: 'Sytem',
    source: 'standard',
    record_name: 'system',
    record_name_plural: 'systems',
  },
  bidding: {
    id: 'b47ae78c-6406-47a3-8014-05b513c9757d',
    internal_name: 'bidding',
    name: 'Bidding',
    source: 'standard',
    record_name: 'record',
    record_name_plural: 'record',
  },
  virtual: {
    id: '78aaa48a-3c9e-4902-b863-00e014a08fe1',
    internal_name: 'virtual',
    name: 'Virtual',
    source: 'standard',
    record_name: 'record',
    record_name_plural: 'record',
  },
  events: {
    id: '917faeee-816d-4594-89e1-6e978d9aedc6',
    internal_name: 'event',
    name: 'Events',
    source: 'standard',
    record_name: 'event',
    record_name_plural: 'events',
  },
  orders: {
    id: 'd6e73169-f16e-4d2a-b33d-e79b1dba6e9b',
    internal_name: 'orders',
    name: 'Orders',
    source: 'standard',
    record_name: 'order',
    record_name_plural: 'orders',
  },
  accounts: {
    id: '575edc78-bfb4-4efa-8225-0fa0a93a1ff0',
    internal_name: 'accounts',
    name: 'Groups',
    source: 'standard',
    record_name: 'group',
    record_name_plural: 'groups',
  },
  contacts: {
    id: '24f40f97-c249-4d86-8328-8f2e9ad69536',
    internal_name: 'contacts',
    name: 'People',
    source: 'standard',
    record_name: 'person',
    record_name_plural: 'people',
  },
  schedules: {
    id: '77517d43-0e33-4994-a2d4-018686cbc696',
    internal_name: 'schedules',
    name: 'Schedules',
    source: 'standard',
    record_name: 'schedule',
    record_name_plural: 'schedules',
  },
  applications: {
    id: '7398718c-0d60-4ee5-80fe-1e32062dd82e',
    internal_name: 'application',
    name: 'Application',
    source: 'standard',
    record_name: 'application',
    record_name_plural: 'applications',
    icon: 'list',
  },
  locations: {
    id: '4a5416ac-44e9-4ce0-8032-8d2b193b89e3',
    record_name_plural: 'locations',
    source: 'standard',
    internal_name: 'locations',
    icon: 'location_city',
    name: 'Locations',
    record_name: 'location',
  },
  locationAreas: {
    id: '815060a4-df4d-4ba8-a68a-6ef80089de70',
    record_name_plural: 'areas',
    source: 'standard',
    internal_name: 'areas',
    icon: 'location_on',
    name: 'Areas',
    record_name: 'area',
  },
  catalogCategories: {
    id: 'a9232cf3-7622-40c1-860f-c1cbd06e7082',
    record_name_plural: 'categories',
    source: 'standard',
    internal_name: 'catalog_categories',
    color: '#e74c3c',
    icon: 'security',
    name: 'Catalog Categories',
    record_name: 'category',
  },
  catalogItems: {
    id: 'af4b337a-c7dc-4e61-947b-5bcfca140274',
    record_name_plural: 'items',
    source: 'standard',
    internal_name: 'catalog_items',
    icon: 'security',
    name: 'Catalog Items',
    record_name: 'item',
  },
  files: {
    id: '8178f4f8-17ad-497f-97dd-3062ebabf6c8',
    internal_name: 'files',
    name: 'Files',
    source: 'standard',
    record_name: 'file',
    record_name_plural: 'files',
    color: '#00A7F0',
    icon: 'insert_drive_file',
  },
  documentRequestTypes: {
    id: '1144f4f8-17ad-497f-97dd-3062ebabf6c1',
    internal_name: 'document_request_types',
    name: 'Document Request Types',
    source: 'standard',
    record_name: 'type',
    record_name_plural: 'types',
    color: '#00A7F0',
    icon: 'attach_file',
  },
  documentRequests: {
    id: 'bd83ddef-a285-499f-9c9c-192d3d9be261',
    internal_name: 'document_requests',
    name: 'Document Requests',
    source: 'standard',
    record_name: 'request',
    record_name_plural: 'requests',
    color: '#00A7F0',
    icon: 'attach_file',
  },
  documentRequestRevisions: {
    id: '2174f4f8-17ad-497f-97dd-3062ebabf6c1',
    internal_name: 'document_request_revisions',
    name: 'Document Request Revisions',
    source: 'standard',
    record_name: 'revision',
    record_name_plural: 'revisions',
    color: '#00A7F0',
    icon: 'attach_file',
  },
  itemQuestions: {
    id: '3174f4f2-27ad-497f-97dd-3062ebabf6c1',
    internal_name: 'item_questions',
    name: 'Item Questions',
    source: 'standard',
    record_name: 'question',
    record_name_plural: 'questions',
  },

  // legacy
  credentialOrders: {
    id: '011bb034-77b5-4be1-a14f-549c673e0e54',
    internal_name: 'credential_orders',
    name: 'Credential Orders',
    source: 'standard',
    record_name: 'order',
    record_name_plural: 'orders',
  },
  credentialOrderLineItems: {
    id: '0a9a6342-207f-45bc-af29-6500d8e162f1',
    internal_name: 'credential_order_line_items',
    name: 'Credential Order Line Items',
    source: 'standard',
    record_name: 'line item',
    record_name_plural: 'line items',
  },
  credentials: {
    id: '4a3530fd-cb40-40a4-8ca6-8d7266c1f4fc',
    internal_name: 'credentials',
    name: 'Passes',
    source: 'standard',
    record_name: 'pass',
    record_name_plural: 'passes',
    color: '#c3005c',
    icon: 'assignment_turned_in',
  },
  schedule: {
    id: 'fa87fa34-9f92-48f2-93f8-d3d76cbeab74',
    internal_name: 'schedule',
    name: 'Schedule',
    source: 'standard',
    record_name: 'schedule',
    record_name_plural: 'schedules',
  },
  sessions: {
    id: 'ea57fa34-9f92-48f2-93f8-d3d76cbeab74',
    internal_name: 'sessions',
    name: 'Sessions',
    source: 'standard',
    record_name: 'session',
    record_name_plural: 'sessions',
  },
  inventory: {
    id: '5084caf6-9b36-4991-a964-4edfab4d846f',
    internal_name: 'inventory',
    name: 'Inventory',
    source: 'standard',
  },
  contactsCheckin: {
    id: '15551116-3912-4e44-a321-6cb491713425',
    internal_name: 'contacts_checkin',
    name: 'Contacts - Checkin',
    source: 'standard',
    record_name: 'checkin',
    record_name_plural: 'checkins',
  },
  forms: {
    id: '6c71dce7-b7ca-4d1b-848f-701e43f9864d',
    internal_name: 'forms',
    name: 'Forms',
    source: 'standard',
    record_name: 'form',
    record_name_plural: 'forms',
    color: '#813CD2',
    icon: 'web',
  },
  formsv3: {
    id: 'fed9028f-a6a4-4009-855e-6a1bfc989835',
    internal_name: 'formsv3',
    name: 'Forms',
    source: 'standard',
    record_name: 'form',
    record_name_plural: 'forms',
    color: '#813CD2',
    icon: 'web',
  },
  submissions: {
    id: '1be157c1-d52a-4115-ad97-ffe34a8c1b20',
    internal_name: 'submissions',
    name: 'Submissions',
    source: 'standard',
    record_name: 'submission',
    record_name_plural: 'submissions',
  },
  portal: {
    id: '101c97c4-c986-46d2-aa35-28c71b6b87cb',
    internal_name: 'portal',
    name: 'Portal',
    source: 'standard',
    record_name: 'portal',
    record_name_plural: 'portals',
  },
  users: {
    id: 'a4fc9748-c38e-48ea-b52c-931b5633541a',
    internal_name: 'users',
    name: 'Users',
    source: 'standard',
    record_name: 'user',
    record_name_plural: 'users',
  },
  catering: {
    id: '02b77381-883b-4b29-8284-9c08ec3fb023',
    internal_name: 'catering',
    name: 'Catering',
    source: 'standard',
    record_name: 'catering',
    record_name_plural: 'catering',
    color: '#F59D00',
    icon: 'restaurant',
  },
  settings: {
    id: 'a763b937-45eb-42d1-ba36-e6f0e866df61',
    internal_name: 'settings',
    name: 'Settings',
    source: 'standard',
    record_name: 'setting',
    record_name_plural: 'settings',
  },
  orgSettings: {
    id: 'b763b937-45eb-42d1-ba36-e6f0e866df61',
    internal_name: 'org_settings',
    name: 'Settings',
    source: 'standard',
    record_name: 'setting',
    record_name_plural: 'settings',
  },
  reports: {
    id: 'a3e21d10-e74c-3520-85c4-0a3f6b6ee9d1',
    internal_name: 'reports',
    name: 'Reports',
    source: 'standard',
    record_name: 'report',
    record_name_plural: 'reports',
  },
  requests: {
    id: '301c97c4-c986-46d2-aa35-28c71b6b87cb',
    internal_name: 'requests',
    name: 'Requests',
    source: 'standard',
    record_name: 'request',
    record_name_plural: 'requests',
  },
  requestsPortal: {
    id: '201c97c4-c986-46d2-aa35-28c71b6b87cb',
    internal_name: 'requests_portal',
    name: 'Request Portal',
    source: 'standard',
    record_name: 'portal',
    record_name_plural: 'portals',
  },
  itemQuestions: {
    id: '3174f4f2-27ad-497f-97dd-3062ebabf6c1',
    internal_name: 'item_questions',
    name: 'Item Questions',
    source: 'standard',
    record_name: 'question',
    record_name_plural: 'questions',
  },
  booths: {
    id: '660443d4-a39b-45e9-a38d-1694839a811b',
    internal_name: 'booths',
    name: 'Booths',
    source: 'standard',
    record_name: 'booth',
    record_name_plural: 'booths',
  },
  sponsorships: {
    id: '52295ced-122c-42d1-af45-8f20c2962e55',
    internal_name: 'sponsorships',
    name: 'Sponsorships',
    source: 'standard',
    record_name: 'sponsorship',
    record_name_plural: 'sponsorships',
  },
  healthPass: {
    id: 'bd4e4074-2bb8-42fa-9e8c-b6dd8b230dde',
    internal_name: 'health_pass',
    name: 'Health Pass',
    source: 'standard',
    record_name: 'pass',
    record_name_plural: 'passes',
  },
};
